import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const RankingService = {
  async getRankingMatches({ clubId, rankingId, playerId }) {
    return safeRequest(
      apiClient
        .get(`/clubs/${clubId}/rankings/${rankingId}/players/${playerId}/matches`)
        .then((response) => response.data),
    );
  },
  async getStandings({ clubId, rankingId }) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .get(`/clubs/${clubId}/rankings/${rankingId}/standings`)
        .then((response) => response.data),
    );
  },
  async updateMyAvailability({ clubId, rankingId, isAvailable }) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .patch(`/clubs/${clubId}/rankings/${rankingId}/my-availability`, { isAvailable })
        .then((response) => response.data),
    );
  },
};
